import * as React from 'react';
import { IgcGridEditingActionsComponent as Component } from 'igniteui-webcomponents-grids/grids/index.js';
import { createComponent } from '../react-props.js';

/**
 * Grid Editing Actions for the Action Strip
 * @class
 */
export const IgrGridEditingActions = /* @__PURE__ */ createComponent({
  tagName: 'igc-grid-editing-actions',
  displayName: 'IgrGridEditingActions',
  elementClass: Component,
  react: React,
  moveBackOnDelete: true,
});

export type IgrGridEditingActions = Component;

/** @deprecated Module register is no longer needed and can be removed */
export const IgrGridEditingActionsModule = Component;
